import React, { useEffect } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import { string, func, bool, object } from 'prop-types'
import { resizableCkeditorStylesForEditTemplate } from 'utils/ckeditorStylingDeffaults'
import styled from 'styled-components'
// import CKEditorInspector from '@ckeditor/ckeditor5-inspector'

const StylesTextEditor = ({
	text,
	ckeditorStyles,
	ckeditorCss,
	onUpdateText,
	block,
	id,
}) => {
	// inject the ckeditor css into the webpage
	useEffect(() => {
		const composedCss = ckeditorCss + resizableCkeditorStylesForEditTemplate

		const style = document.createElement('style')
		style.appendChild(document.createTextNode(composedCss))

		document.head.appendChild(style)

		// Clean-up function
		return () => {
			document.head.removeChild(style)
		}
	}, [ckeditorCss])

	return (
		<Wrapper
			$flexDirection="column"
			style={{
				flexGrow: 1,
				minWidth: 0,
			}}>
			<CKEditor
				id={id}
				onReady={(editor) => {
					// CKEditorInspector.attach(editor)
				}}
				editor={Editor}
				config={{
					style: ckeditorStyles,
				}}
				onChange={(event, editor) => onUpdateText(editor.getData(), 'text')}
				data={text}
				disabled={block}
			/>
		</Wrapper>
	)
}

StylesTextEditor.propTypes = {
	text: string,
	onUpdateText: func,
	block: bool,
	getEditor: func,
	ckeditorCss: string,
	ckeditorStyles: object,
	id: string,
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: ${({ $flexDirection = 'row' }) => $flexDirection};
	justify-content: ${({ $justifyContent = 'normal' }) => $justifyContent};
	align-items: ${({ $alignItems = 'normal' }) => $alignItems};
`

export default StylesTextEditor
